import KAccountSettingsInfoForm from "./KAccountSettingsInfoForm";
import KAccountSettingsPasswordForm from "./KAccountSettingsPasswordForm";

export default {
	name: "KAccountSettings",

	render() {
		return <div>
			<KAccountSettingsInfoForm></KAccountSettingsInfoForm>
			<KAccountSettingsPasswordForm class="mt-4"></KAccountSettingsPasswordForm>
		</div>;
	}
};
